import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useI18n } from "./i18n/i18n";
import { DemoCatalogue } from "./pages/DemoCatalogue";
import { Automations } from "./pages/Automations";
import { Home } from "./pages/Home";
import { NotFound } from "./pages/NotFound";

const UnifiedDemo = lazy(() => import("./demos/UnifiedDemo"));

function DemoLoading() {
  const { language } = useI18n();
  return <div className="route-loading" role="status"><span />{language === "it" ? "Preparazione demo interattiva…" : "Preparing interactive demo…"}</div>;
}

export function App() {
  return (
    <Suspense fallback={<DemoLoading />}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/websites" element={<DemoCatalogue />} />
        <Route path="/demos" element={<Navigate to="/websites" replace />} />
        <Route path="/automations" element={<Automations />} />
        <Route path="/demos/:slug" element={<UnifiedDemo />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
